module.exports = __webpack_public_path__ + "static/img/hi_IN.36e345d.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/langs/hi_IN.png
// module id = n1bv
// module chunks = 0 1 2